import { FC } from 'react';
import { CategoryOption } from '@forms-exp/types';
import { ChecklistField, CustomChangeEvent } from '@weave/design-system';
import useStore from '@forms-exp/store';
import { checklistFieldStyle } from './inline-categorized-checklist.style';

interface InlineCategorizedChecklistProps {
  fieldProps: any;
  options: CategoryOption[];
  categoryId: string;
  onUpdateValue: () => void;
}

const InlineCategorizedChecklist: FC<InlineCategorizedChecklistProps> = ({
  fieldProps,
  options,
  categoryId,
  onUpdateValue,
}) => {
  const { updateFieldValue } = useStore();

  function changeHandler(e?: CustomChangeEvent<string>) {
    if (!e) {
      return;
    }

    const selectedOptionValue = e.value;
    if (!selectedOptionValue) {
      return;
    }

    updateFieldValue({
      name: fieldProps.name,
      value: selectedOptionValue,
      toggleValue: true,
    });
    onUpdateValue();
  }

  return (
    <ChecklistField
      {...fieldProps}
      label=""
      onChange={changeHandler}
      css={checklistFieldStyle}
    >
      {options.map((option) => {
        if (!option || !option.value) {
          return null;
        }

        return (
          <ChecklistField.Option
            key={`${categoryId}-opt-${option.value}`}
            name={option.value}
          >
            {option.label}
          </ChecklistField.Option>
        );
      })}
    </ChecklistField>
  );
};

export default InlineCategorizedChecklist;
